/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PriceDisplayComponent } from './price-display/price-display.component';
import { PriceInputComponent } from './price-input/price-input.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SharedComponentsModule as WellSharedComponentsModule } from '@well/shared-components';
import { SelectModule, Select } from 'primeng/select';
import { InputTextModule } from 'primeng/inputtext';
import { PrimengUtilsModule } from '@irian-ro/primeng-utils-module';
import { SharedComponentsModule } from '@irian-ro/shared-components-module';
import { InputNumberModule, InputNumber } from 'primeng/inputnumber';
import { FormInlineErrorDirective } from '@irian-ro/shared-ui';
import { FloatLabel } from 'primeng/floatlabel';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    WellSharedComponentsModule,
    SelectModule,
    InputTextModule,
    PrimengUtilsModule,
    SharedComponentsModule,
    InputNumberModule,
    FormInlineErrorDirective,
    FloatLabel,
    InputNumber,
    Select],
  declarations: [PriceDisplayComponent, PriceInputComponent],
  exports: [PriceDisplayComponent, PriceInputComponent],
})
export class PriceManagementModule {}
